import React from 'react';
import { AuditOutcome } from '../../components/services/auditService';

const OUTCOME_CLASSES: Record<AuditOutcome, string> = {
  Succeeded: 'bg-green-900/40 text-green-300 border-green-700',
  Denied: 'bg-amber-900/40 text-amber-300 border-amber-700',
  Failed: 'bg-red-900/40 text-red-300 border-red-700',
};

const OutcomeBadge = ({ outcome }: { outcome: AuditOutcome }) => (
  <span className={`inline-block px-2 py-0.5 text-xs rounded border ${OUTCOME_CLASSES[outcome] ?? 'border-gray-600 text-gray-300'}`}>
    {outcome}
  </span>
);

export default OutcomeBadge;
